import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCanQueryAvailability, selectReferenceMaterial } from "~/features/configurator/Linear/redux/selectors";
import dayjs from "dayjs";
import { requestAvailabilityData } from "~/domains/product/redux/actions";
import { selectAvailabilityData } from "~/domains/product/redux/selectors";
import { useLinearProductInfo } from "~/features/configurator/Linear/redux/useLinearProductInfo";

let lastKbHash: string | undefined = undefined;

function isNewKbHash(kbHash?: string) {
  return lastKbHash !== kbHash;
}

export const useLinearAvailability = () => {
  const configuratorProduct = useLinearProductInfo();
  const canQuery = useSelector(selectCanQueryAvailability);

  const kbHash = useSelector(selectReferenceMaterial);

  const dispatch = useDispatch();
  const { state, data } = useSelector(
    selectAvailabilityData({ productCode: configuratorProduct.code, priceReference: "" }),
  ) ?? { state: kbHash ? "loading" : "loaded", data: undefined };

  useEffect(() => {
    if (isNewKbHash(kbHash) && !!kbHash && canQuery) {
      lastKbHash = kbHash;
      dispatch(requestAvailabilityData(configuratorProduct, false, undefined, true));
    }
  }, [configuratorProduct.configId, canQuery, kbHash]);

  if (data) {
    let leadTime = null;
    const leadTimeDate = data.packagingInformation[0]?.replenishmentLeadTimeDate;
    if (leadTimeDate) {
      leadTime = Math.ceil(dayjs(leadTimeDate).diff(dayjs(), "day") / 7);
    }
    return {
      leadTime: leadTime,
      errorLoadingAvailability: false,
      isLoadingAvailability: false,
    };
  }
  return {
    leadTime: null,
    errorLoadingAvailability: canQuery && state === "error",
    isLoadingAvailability: canQuery && state === "loading",
    isQueryAllowed: canQuery,
  };
};
